import { navigate } from "lib/routes/navigate"

export const LEGISLATION_LIBRARY_ROOT = "/authoring/legislation"

export function legislationLibraryRootPath() {
    return LEGISLATION_LIBRARY_ROOT
}

export function legislationLibraryItemPath(id) {
    return `${LEGISLATION_LIBRARY_ROOT}?id=${id}`
}

export function legislationDetailPath(id) {
    return `${LEGISLATION_LIBRARY_ROOT}/${id}`
}

export function navigateLegislationLibrary() {
    navigate(LEGISLATION_LIBRARY_ROOT)
}

export function navigateLegislationLibraryItem(id) {
    navigate(legislationLibraryItemPath(id))
}

export function navigateLegislationDetail(id) {
    navigate(legislationDetailPath(id))
}
